export default "__VITE_ASSET__9a6893c5__"